import React, { useMemo } from "react";
import useProductMatchScore from "../../hooks/useProductMatchScore";
import { useProductSocialProof } from "../../hooks/useProductSocialProof";
import {
  getMatchLabelContext,
  MATCH_LABEL_STATES,
} from "../../utils/matchLabelContext";
import MatchFusedScoreLine from "../product/MatchFusedScoreLine";

/**
 * Match % + cluster social proof for feed product cards (logged-in).
 */
const FeedMatchFusedLine = ({
  product,
  wizardRevision = 0,
  className = "",
  relatedClassName = "",
  activeDecision = null,
  shopperCategoryKeys = null,
  forceAligned = false,
  precomputedScore = null,
}) => {
  const productId = product?._id || product?.id;
  const hasPrecomputedScore = Number.isFinite(Number(precomputedScore));
  const engineScore = useProductMatchScore(product, {
    wizardRevision,
    precomputed: hasPrecomputedScore
      ? {
          enabled: true,
          ready: true,
          score: Number(precomputedScore),
        }
      : null,
  });

  const score = engineScore;

  const labelContext = useMemo(() => {
    if (forceAligned) {
      return {
        state: MATCH_LABEL_STATES.ALIGNED,
        qualifier: null,
        tooltip: null,
      };
    }
    return getMatchLabelContext(product, activeDecision, {
      shopperCategoryKeys: shopperCategoryKeys || [],
    });
  }, [product, activeDecision, shopperCategoryKeys, forceAligned]);

  const { proof } = useProductSocialProof(productId, Boolean(productId));

  if (labelContext.state === MATCH_LABEL_STATES.EXPLORE && score != null) {
    return null;
  }

  const mergedClassName = [
    className,
    labelContext.state === MATCH_LABEL_STATES.RELATED && relatedClassName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <MatchFusedScoreLine
      score={score}
      proof={proof}
      className={mergedClassName}
      as="p"
      labelContext={labelContext}
      activeDecision={activeDecision}
      compact
    />
  );
};

export default FeedMatchFusedLine;
